import "./Manuales.css";
import coverLVT from "../assets/manualcover_LVT.jpg"
import coverSPC from "../assets/manualcover_SPC.jpg"
import coverUV from "../assets/manualcover_UV.jpg"
import coverWPC from "../assets/manualcover_WPC.jpg"

function Manuales() {

    return (
        <section>

            <article className="section-title title-manuales">
                <h2 className="title-line">Manuales de Instalación y garantía</h2>
                <div className="title-line-line"></div>
            </article>

            <section className="grid-manuales">
                <article className="grid-manuales-1">
                    <img src={coverLVT} />
                    <a href="/manual/manual_lvt.pdf">Descargar</a>
                </article>

                <article className="grid-manuales-2">
                    <img src={coverSPC} />
                    <a href="/manual/manual_spc.pdf">Descargar</a>
                </article>

                <article className="grid-manuales-3">
                    <img src={coverWPC} />
                    <a href="/manual/manual_wpc.pdf">Descargar</a>
                </article>

                <article className="grid-manuales-4">
                    <img src={coverUV} />
                    <a href="/manual/manual_uv.pdf">Descargar</a>
                </article>
            </section>

        </section>
    )
}

export default Manuales;